import { render, staticRenderFns } from "./PastDepartmentsSection.vue?vue&type=template&id=254212c6&"
import script from "./PastDepartmentsSection.vue?vue&type=script&lang=js&"
export * from "./PastDepartmentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports